import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AssessorForm } from 'src/app/_models/assessorForm';
import { ApiService } from 'src/app/_services/api.service';
import {AmpUserInfo} from '../file-online-v2/models/AmpUserInfo';
import {LegendItemModel} from './legend-item.model';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss']
})
export class StatusComponent implements OnInit {

  fileItems: AssessorForm[];
  length: number;
  userInfo: AmpUserInfo | null;

  page = 1;
  pageSize = 10;
  collectionSize: number;
  forms: AssessorForm[];

  legendItems: LegendItemModel[] = [
    new LegendItemModel('Canceled', 'The form has been canceled by user.'),
    new LegendItemModel('Completed', 'The form request has been completed. Case is closed.'),
    new LegendItemModel('Expired', 'The form was not completed within the 24-hour timeframe.'),
    new LegendItemModel('Failed', 'An error occurred during processing. Please resubmit the form.'),
    new LegendItemModel('Incomplete', 'The form request is incomplete. Please contact the Office of the Assessor for assistance.'),
    new LegendItemModel('Pending Signature', 'The form has been started, but not yet submitted.'),
    new LegendItemModel('Submitted', 'The form has been submitted and is currently being processed or has been processed.'),
  ];

  constructor(private apiService: ApiService) {
  }

  ngOnInit(): void {
    this.loadAmpCredentials();
  }

  get shouldShowWUStart(): boolean {
    switch (window.location.host) {
      case 'localhost:4200':
      case 'assessorate2.lacounty.gov':
      case 'assessorate3.lacounty.gov':
      // case 'assessorpstst.lacounty.gov':
        return true;
      default:
        return false;
    }
  }

  async loadAmpCredentials(): Promise<void> {
    const [ampUserInfo] = await this.apiService.getAmpUserInfo();
    this.userInfo = ampUserInfo;
    this.getFiles(ampUserInfo.email);
  }

  refreshForms(): void {
    this.forms = this.fileItems
      .map((file, i) => ({id: i + 1, ...file}))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }

  getFiles(email: string): void {
    this.apiService.getAssessorFormStatus(email).subscribe(data => {
      this.fileItems = data;
      this.length = this.fileItems.length;
      this.collectionSize = this.fileItems.length;
      this.refreshForms();
    });
  }

  accessLink(id: string): void {
    this.apiService.accessLink(id).subscribe(data => {
      if (this.isSafari) {
        window.location.href = data.link;
      } else {
        window.open(data.link);
      }
    });
  }

  isSafari(): boolean {
    const userAgent = navigator.userAgent;
    return /^((?!chrome|android).)*safari/i.test(userAgent);
  }

  getWorkUnitNumber(item: AssessorForm): string {
    if (item.isLegacySubmission) { return 'N/A'; }
    if (!item.generatesWorkUnitNumber) { return 'N/A'; }
    return item.workUnitId <= 0 ? '' : item.workUnitNumber;
  }

  manuallyKickOffWorkUnit(item: AssessorForm): void {
    this.apiService.manuallyKickOffWorkUnit(item.clientId, item.nextRequiredAction).subscribe(o =>  {
      switch (item.nextRequiredAction) {
        case 'complete':
          item.workUnitId = -1;
          item.status = 'Submitted';
          break;
        case 'partyComplete':
          item.nextRequiredAction = 'complete';
          break;
      }
    });
  }

  getCompleteButtonText(item: AssessorForm): string {
    switch (item.nextRequiredAction) {
      case 'partyComplete':
        return 'Complete First Signer';
      case 'complete':
        return item.numRequiredSigners > 1 ? 'Complete Second Signer' : 'Complete';
      default:
        return 'N/A';
    }
  }
}

